import Segmented from './segmented';

export default Segmented;
export type * from './types';
